/**
 * Action and mutation types for wordpress/posts module
 */
const types = {
  FETCH: 'fetch',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  SELECT: 'select',
  DESELECT: 'deselect'
}

export default types



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/posts/types.js